// This value is also present in the back-end API application,
// so if you need to change this value do not forget to change it in both places.
const archivableAfterInDays = 9;

export default archivableAfterInDays;
